// Lazy load:
// https://router.vuejs.org/zh-cn/advanced/lazy-loading.html

const Resource = () => import('@/containers/SystemManage/Resource/Resource.vue');
const ResourceDev = () => import('@/containers/SystemManage/ResourceDev/ResourceDev.vue');
const OperationLog =() =>import('@/containers/SystemManage/OperationLog/OperationLog.vue')

const ArchitectureManagement = () => import('@/containers/BasicConfig/ArchitectureManagement/ArchitectureManagement.vue');
const DeptDetail = () => import('@/containers/BasicConfig/ArchitectureManagement/DeptDetail.vue');
const PositionDetail = () => import('@/containers/BasicConfig/ArchitectureManagement/PositionDetail.vue');
const ResourceDevSync = () => import('@/containers/SystemManage/ResourceDev/ResourceDevSync.vue');
const ResourceDevSyncLog = () => import('@/containers/SystemManage/ResourceDev/ResourceDevSyncLog.vue');

// 员工管理
const Staff = () => import('@/containers/StaffManage/Staff.vue');
const StaffOperation = () => import('@/containers/StaffManage/StaffOperation.vue');
const FunctionalManagement = () => import('@/containers/BasicConfig/FunctionalManagement/FunctionalManagement.vue');
const ConfigFunctional = () => import('@/containers/BasicConfig/FunctionalManagement/ConfigFunctional.vue');
const OrganizationalManagement = () => import('@/containers/BasicConfig/OrganizationalManagement/OrganizationalManagement.vue');
const AuthWorkbench = () => import('@/containers/AuthConfig/AuthWorkbench/AuthWorkbench.vue');
const AuthConfig = () => import('@/containers/AuthConfig/AuthWorkbench/AuthConfig.vue');

//权限申请
const AuthQuery = () => import('@/containers/AuthApply/AuthQuery.vue');
const AuthApply = () => import('@/containers/AuthApply/AuthApply.vue');
const MyApply = () => import('@/containers/AuthApply/MyApply.vue');

export default {
  'm-system': {
    icon: 'izk-nav-system',
    label: '系统管理',
    pages: {
      'p-resource': {
        label: '资源排序管理',
        store: 'resource',
        path: 'system/resource-manage',
        component: Resource,
      },
      'p-resource_dev': {
        label: '菜单权限管理',
        store: 'resourceDev',
        path: 'system/resource-manage-dev',
        component: ResourceDev,
      },
      'p-operation_log': {
        label: '用户操作日志',
        store: 'operationLog',
        path: 'system/operation-log-manage',
        component: OperationLog,
      },
      'p-resourceDev_sync': {
        label: '批量同步资源点',
        store: 'resourceDevSync',
        path: 'system/resource-dev-sync',
        component: ResourceDevSync,
        hidden:true,
      },
      'p-resourceDev_syncLog': {
        label: '同步资源点日志',
        store: 'resourceDevSyncLog',
        path: 'system/resource-dev-syncLog',
        component: ResourceDevSyncLog,
        hidden:true,
      },
    },
  },
  'm-basicConfig': {
    icon: 'izk-nav-basicConfig',
    label: '基础信息配置',
    pages: {
      'p-architectureManagement': {
        label: '组织架构管理',
        store: 'architectureManagement',
        path: 'basicConfig/architecture-management',
        component: ArchitectureManagement,
        keepAlive:true
      },
      'p-deptDetail': {
        label: '部门详情',
        store: 'deptDetail',
        path: 'basicConfig/architecture-management/dept-detail',
        component: DeptDetail,
        hidden:true,
      },
      'p-positionDetail': {
        label: '职位详情',
        store: 'positionDetail',
        path: 'basicConfig/architecture-management/position-detail',
        component: PositionDetail,
        hidden:true,
      },
      'p-functionalManagement': {
        label: '职能包管理',
        store: 'functionalManagement',
        path: 'basicConfig/functional-management',
        component: FunctionalManagement,
        keepAlive:true
      },
      'p-configFuntional': {
        label: '配置职能包',
        store: 'configFuntional',
        path: 'basicConfig/functional-management/config-functional',
        component: ConfigFunctional,
        hidden:true,
      },
      'p-organizationalManagement': {
        label: '组织管理',
        store: 'organizationalManagement',
        path: 'basicConfig/organizational-management',
        component: OrganizationalManagement,
      },
    },
  },
  'm-staff': {
    icon: 'izk-nav-staff',
    label: '员工管理',
    pages: {
      'p-staff_list': {
        label: '员工列表',
        store: 'staffList',
        path: 'staff/list',
        component: Staff
      },
      'p-staff_operation': {
        label: '新增员工',
        store: 'staffOperation',
        path: 'staff/operation',
        component: StaffOperation,
        hidden: true
      }
    }
  },
  'm-authConfig': {
    icon: 'izk-nav-authConfig',
    label: '用户权限配置',
    pages: {
      'p-authWorkbench': {
        label: '权限处理工作台',
        store: 'authWorkbench',
        path: 'authConfig/auth-workbench',
        component: AuthWorkbench,
        keepAlive:true
      },
      'p-authConfig': {
        label: '权限配置',
        store: 'authConfig',
        path: 'authConfig/auth-config',
        component: AuthConfig,
        hidden:true,
      },
    }
  },
  'm-authApply': {
    icon: 'izk-nav-basicConfig',
    label: '权限申请',
    pages: {
      'p-authQuery': {
        label: '权限查询',
        store: 'authQuery',
        path: 'authApply/auth-query',
        component: AuthQuery,
        keepAlive:true
      },
      'p-authApply': {
        label: '权限申请',
        store: 'authApply',
        path: 'authApply/auth-apply',
        component: AuthApply,
      },
      'p-myApply': {
        label: '我的申请',
        store: 'myApply',
        path: 'authApply/my-apply',
        component: MyApply,
      },
    }
  }
};



// WEBPACK FOOTER //
// ./src/router/menu.js